import React, { useEffect } from "react";
import LicenseApiKeysComp from "../Components/LicenseApiKeys/LicenseApiKeys";
const LicenseApiKeys = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <LicenseApiKeysComp />;
};

export default LicenseApiKeys;
